module.exports = __webpack_public_path__ + "static/media/blogLogo.484f5463.svg";